import React from 'react'
import PropTypes from 'prop-types'
import {Icon, Image, Segment, Step, Container, Dimmer, Loader, Button, Label} from 'semantic-ui-react'
import {STEPS, PRODUCT_TYPES} from '../../../constants'
import './ContentView.scss'

import Categories from '../../../components/Categories/containers/CategoriesContainer'
import Products from '../../../components/Products/containers/ProductsContainer'
import Billers from '../../../components/Billers/containers/BillersContainer'
import ShoppingCart from '../../../components/ShoppingCart/containers/ShoppingCartContainer'

import getApp from '../../../components/Applications'

import {getLanguageScope} from '../../../helpers'

const _i18n = getLanguageScope('shop');

export default class MarketView extends React.Component {

  constructor(props) {
    super(props);
  }

  setAttr(tabStep) {
    const {step, changeStep} = this.props;

    function set(active, disabled, onClick = () => null) {
      return {active, disabled, onClick}
    }

    const stepMap = {
      [STEPS.CATEGORIES]: {
        [STEPS.CATEGORIES]: set(true, false),
        [STEPS.PRODUCTS]: set(false, true),
        [STEPS.APPLICATION]: set(false, true),
        [STEPS.SHOPPING_CART]: set(false, false, () => changeStep(STEPS.SHOPPING_CART))
      },
      [STEPS.PRODUCTS]: {
        [STEPS.CATEGORIES]: set(false, false, () => changeStep(STEPS.CATEGORIES)),
        [STEPS.PRODUCTS]: set(true, false),
        [STEPS.APPLICATION]: set(false, true),
        [STEPS.SHOPPING_CART]: set(false, false, () => changeStep(STEPS.SHOPPING_CART))
      },
      [STEPS.APPLICATION]: {
        [STEPS.CATEGORIES]: set(false, true),
        [STEPS.PRODUCTS]: set(false, true),
        [STEPS.APPLICATION]: set(true, false),
        [STEPS.SHOPPING_CART]: set(false, true)
      },
      [STEPS.SHOPPING_CART]: {
        [STEPS.CATEGORIES]: set(false, false, () => changeStep(STEPS.CATEGORIES)),
        [STEPS.PRODUCTS]: set(false, true),
        [STEPS.APPLICATION]: set(false, true),
        [STEPS.SHOPPING_CART]: set(true, false)
      }
    };

    return stepMap[step][tabStep]
  }

  renderStep() {
    const {step, selectedCategory, appGuid} = this.props;

    if (step === STEPS.CATEGORIES) {
      return <Categories/>
    }

    if (step === STEPS.PRODUCTS) {

      if (selectedCategory === PRODUCT_TYPES.BILLPAYMENT) {
        return <Billers/>
      }

      return <Products/>
    }

    if (step === STEPS.APPLICATION) {
      const Application = getApp(appGuid);
      return <Application/>
    }

    if (step === STEPS.SHOPPING_CART) {
      return <ShoppingCart/>
    }

  }

  renderCountOfPayments(){
    const {paymentsCount, step} = this.props;

    return (
      <Label circular style={{marginLeft: 10}} size='tiny'
             color={(step === STEPS.SHOPPING_CART) ? 'blue' : 'black'}>
        {paymentsCount}
      </Label>
    )
  }

  renderFocusColor(focusStep){
    const {step} = this.props;

    if(step === focusStep) {
      return {color:'blue'}
    }
  }

  render() {
    return (
      <div>

        <Step.Group size={'small'} stackable='tablet' attached='top'>
          <Step {...this.setAttr(STEPS.CATEGORIES)}>
            <Icon {...this.renderFocusColor(STEPS.CATEGORIES)} name='bars'/>
            <Step.Content>
              <Step.Title>{_i18n('transaction_type')}</Step.Title>
            </Step.Content>
          </Step>

          <Step {...this.setAttr(STEPS.PRODUCTS)}>
            <Icon {...this.renderFocusColor(STEPS.PRODUCTS)} name='box'/>
            <Step.Content>
              <Step.Title>{_i18n('product')}</Step.Title>
            </Step.Content>
          </Step>

          <Step {...this.setAttr(STEPS.APPLICATION)}>
            <Icon {...this.renderFocusColor(STEPS.APPLICATION)} name='edit'/>
            <Step.Content>
              <Step.Title>{_i18n('details')}</Step.Title>
            </Step.Content>
          </Step>

          <Step {...this.setAttr(STEPS.SHOPPING_CART)}>
            <Icon {...this.renderFocusColor(STEPS.SHOPPING_CART)} name='cart'/>
            <Step.Content>
              <Step.Title>
                {_i18n('review')}
                {this.renderCountOfPayments()}
              </Step.Title>
            </Step.Content>
          </Step>
        </Step.Group>

        <Segment className={'main-segment'} attached>

          {this.renderStep()}

        </Segment>

      </div>
    )
  }
}

MarketView.propTypes = {
  changeStep: PropTypes.func,
  step: PropTypes.string,
  loadingContent: PropTypes.bool,
  appGuid: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/layouts/Content/components/MarketView.js